module.exports = __webpack_public_path__ + "static/GorditaLight-fde8b95085cf06778e072c5b580394b1.woff";